export default "__VITE_ASSET__DnK15NEZ__"